import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useSuperIntl } from "../_";
import { useGlobalSetting } from "../GlobalSetting";
import { PageContainer, RouteContext } from '@ant-design/pro-components';
import { ArrowLeft } from '@icon-park/react';
import React, { useContext } from 'react';
import { useStyles } from "./_.style";
import { SuperPageContainerJumper } from "./Jumper";
export var SuperPageContainer = function SuperPageContainer(properties) {
  var _globalSetting$superP, _properties$header, _properties$header$ti, _properties$header2, _properties$header$ti2, _properties$header3, _properties$header4, _properties$header5;
  var _useGlobalSetting = useGlobalSetting(),
    _useGlobalSetting2 = _slicedToArray(_useGlobalSetting, 1),
    globalSetting = _useGlobalSetting2[0];
  var intl = useSuperIntl();
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  var value = useContext(RouteContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, ((_globalSetting$superP = globalSetting.superPageContainer) === null || _globalSetting$superP === void 0 ? void 0 : _globalSetting$superP.showJumper) && /*#__PURE__*/React.createElement(SuperPageContainerJumper, null), /*#__PURE__*/React.createElement(PageContainer, _extends({
    className: styles.container,
    childrenContentStyle: {
      paddingBlock: 0,
      paddingInline: 0
    },
    breadcrumbRender: function breadcrumbRender(_properties_, element) {
      var _properties_$breadcru;
      // -
      var items = ((_properties_$breadcru = _properties_.breadcrumb) === null || _properties_$breadcru === void 0 ? void 0 : _properties_$breadcru.items) || [];
      // -
      if (items.length > 3) {
        var _items$at;
        return /*#__PURE__*/React.cloneElement(element, {
          separator: '>',
          items: [{
            title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArrowLeft, null), " ", intl.formatMessage({
              id: 'Go Back'
            })),
            breadcrumbName: intl.formatMessage({
              id: 'Go Back'
            }),
            linkPath: (_items$at = items.at(-2)) === null || _items$at === void 0 ? void 0 : _items$at.linkPath
          }, {
            type: 'separator',
            separator: '|'
          }].concat(_toConsumableArray(items.slice(-2)))
        });
      } else {
        return false;
      }
    },
    tabProps: {
      type: 'card'
    }
  }, properties, {
    tabList: properties.tabList || [],
    header: _objectSpread(_objectSpread({}, (_properties$header = properties.header) !== null && _properties$header !== void 0 ? _properties$header : {}), {}, {
      title: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#181A1D',
          fontWeight: 500,
          fontSize: 24,
          lineHeight: '32px'
        },
        title: (_properties$header$ti = (_properties$header2 = properties.header) === null || _properties$header2 === void 0 ? void 0 : _properties$header2.title) !== null && _properties$header$ti !== void 0 ? _properties$header$ti : value.title
      }, (_properties$header$ti2 = (_properties$header3 = properties.header) === null || _properties$header3 === void 0 ? void 0 : _properties$header3.title) !== null && _properties$header$ti2 !== void 0 ? _properties$header$ti2 : value.title), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 4,
          color: '#707275',
          fontSize: 12,
          lineHeight: '20px',
          // 抵消一下 Ant Design 设置的 font-weight
          fontWeight: 'unset'
        }
      }, /*#__PURE__*/React.createElement("span", {
        title: (_properties$header4 = properties.header) === null || _properties$header4 === void 0 ? void 0 : _properties$header4.description
      }, (_properties$header5 = properties.header) === null || _properties$header5 === void 0 ? void 0 : _properties$header5.description), /*#__PURE__*/React.createElement("span", {
        className: styles.learner
      }, intl.formatMessage({
        id: 'Learn More'
      }))))
    })
  })));
};